
import {
    SET_VALIDATION_ERROR_MESSAGE,
    CLEAR_VALIDATION_ERROR_MESSAGE
} from '../../containers/SpockViewPage/actions/actionConstants';




const initialState = {
    errorMessage : null
};

export default function(state = initialState, action){
    switch(action.type){
        case SET_VALIDATION_ERROR_MESSAGE :
        return Object.assign(
            {},
            state,
            {
             errorMessage : action.payload
            }
        );
        case CLEAR_VALIDATION_ERROR_MESSAGE :
        return Object.assign(
            {},
            state,
            {
             errorMessage : null
            }
        );

        default:
        return state;

    }

}